export default class ThemeToggle {
  constructor() {
    this.htmlElement = document.documentElement;
    this.setInitialTheme();
    this.bindEvents();
  }

  setInitialTheme() {
    const storedTheme = localStorage.getItem("theme");
    const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (storedTheme === "dark" || (!storedTheme && systemPrefersDark)) {
      this.htmlElement.classList.add("dark");
      this.htmlElement.classList.remove("light");
    } else if (storedTheme === "light" || (!storedTheme && !systemPrefersDark)) {
      this.htmlElement.classList.add("light");
      this.htmlElement.classList.remove("dark");
    }
  }

  bindEvents() {
    // Se espera a que el DOM cargue solo para enlazar el botón
    document.addEventListener("DOMContentLoaded", () => {
      const themeToggleBtn = document.getElementById("theme-toggle");
      if (themeToggleBtn) {
        themeToggleBtn.addEventListener("click", () => this.toggle());
      }
    });

    // Opcional: Escuchar si el usuario cambia el tema desde el Sistema Operativo
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
      if (!localStorage.getItem("theme")) this.setInitialTheme();
    });
  }

  toggle() {
    const isDark = this.htmlElement.classList.contains("dark");
    this.htmlElement.classList.toggle("dark", !isDark);
    this.htmlElement.classList.toggle("light", isDark);
    localStorage.setItem("theme", isDark ? "light" : "dark");
  }
}